import { config } from "../helpers/domain-config";
import { getUid, webstore } from "../helpers/auth-helpers";
import { getRockmanId } from "../helpers/auth-helpers";
import axios from "axios";

/* eslint-disable max-len */
const UnsubLinks = {
  OM: "https://n.xr-academy.com/unsubscribe/om?country=om&domain=om.xr-academy.com",
  ZA: "https://n.xr-academy.com/unsubscribe/za/?country=za&domain=za.xr-academy.com",
  DE: "https://n.xr-academy.com/unsubscribe/de/?country=de&domain=de.xr-academy.com",
  CA: "https://n.mobiovr.com/unsubscribe/ca/?country=ca&domain=ca.mobiovr.com&platform=mcb",
  CZ: "https://n.xr-academy.com/unsubscribe/cz/?lang=cz",
  MY: "https://checksubscription.com/?c=my",
  UMOBILE: "https://checksubscription.com/?c=my",
  SG: "https://checksubscription.com/?c=sg",
  QA: "https://n.xr-academy.com/unsubscribe/qa?lang=en",
  PS: "https://n.xr-academy.com/unsubscribe/ps?lang=ar",
  ES: "https://emocion.fonestarz.com/micuentamovil/",
  PK: "https://checksubscription.com/?c=pk",
  TH: "https://checksubscription.com/?c=th",
  FR: "https://checksubscription.com/?c=fr",
  BH: "https://checksubscription.com/?c=bh",
  ID: {
    PKG1: "http://m.xr-academy.com/unsubscribe/id",
    PKG2: "http://m2.xr-academy.com/unsubscribe/id",
  },
  CH: "https://checksubscription.com/?c=ch",
  PORTAL: "https://checksubscription.com/?c=hk",
  DZ: "https://checksubscription.com/?c=dz",
  PH: "https://checksubscription.com/?c=ph",
  IQ: "https://checksubscription.com/?c=iq",
  KW: "https://checksubscription.com/?c=kw",
};
/* eslint-enable max-len */

export const getUnsubLink = (packageKey) => {
  const domain = config.subdomain.toUpperCase();
  const uid = webstore.getProperty("token");
  const rid = webstore.get()
    ? webstore.get().rockmanId
      ? webstore.get().rockmanId
      : null
    : null;
  if (Object.keys(UnsubLinks).indexOf(domain) >= 0) {
    const appendToken =
      ["ES", "MY", "PK", "TH", "MY", "SG", "UMOBILE", "FR"].includes(domain) ===
      false;
    if (domain === "ID" && packageKey) {
      return UnsubLinks[domain][packageKey];
    } else if (uid && domain === "GH" && appendToken) {
      return `${UnsubLinks[domain]}?token=${uid}`;
    } else if (uid && appendToken) {
      return `${UnsubLinks[domain]}&token=${uid}`;
    } else if (rid && domain === "FR") {
      return `${UnsubLinks[domain]}&rid=${rid}`;
    } else {
      return UnsubLinks[domain];
    }
  }
  return null;
};

export const UnsubscribePE = async () => {
  const rockmanId = getRockmanId();

  try {
    const response = await axios.get(
      "/api/unsubscribe?country=pe&token=" + rockmanId
    );
    if (response.data.success) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const UnsubscribeGH = async () => {
  const rockmanId = getRockmanId();

  try {
    const response = await axios.get(
      "/api/unsubscribe?domain=gh.afri-verse.com&country=gh&token=" + rockmanId
    );
    if (response.data.success) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const UnsubscribeSN = async () => {
  const uid = getUid();

  try {
    const response = await axios.get(
      "/api/unsubscribe?country=sn&token=" + uid
    );
    console.log("response - ", response.data);
    if (response.data.success) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const UnsubscribePT = async () => {
  const uid = getUid();

  try {
    const response = await axios.get(
      "/api/unsubscribe?domain=pt.academiavr.com&country=pt&token=" + uid
    );
    console.log("response - ", response.data);
    if (response.data.success) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const UnsubscribeAPI = (product, token) => {
  const { country } = config;

  return fetch(
    `/api/unsubscribe?${
      product ? `domain=${product}&` : ""
    }country=${country}&token=${token}`
  )
    .then((response) => response.json())
    .then((data) => !!data.success)
    .catch((err) => {
      return false;
    });
};
export const unsubscribe = (subdomain) => {
  const rockmanId = getRockmanId();
  const uid = getUid();
  const domain = window.location.hostname;

  const config = {
    pt: [domain, uid],
    sn: [null, uid],
    pe: [null, rockmanId],
    gh: [domain, rockmanId],
    qa: [domain, uid],
    app: [domain, uid],
    rs: [domain, uid],
  };

  if (!config[subdomain]) {
    return;
  }
  return UnsubscribeAPI(...config[subdomain]);
};
